import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
//Modelos
import { ServerModel } from './../../models/server.model';
import { DomainsModel } from './../../models/domains.model';
import { DatabasesModel} from './../../models/databases.model';
import { BackupsModel } from './../../models/backups.model';
import { UsersModel } from './../../models/users.model';
import { NotificationModel } from './../../models/notifications.model';
import { StorageModel } from './../../models/storage.model';
import { NetworkModel } from './../../models/networks.model';
import { ManualModel } from './../../models/manuals.model';
import { SubdomainModel } from './../../models/subdomains.model';
import { AndroidModel} from './../../models/android.model';
import { QtoolsModel } from './../../models/qtools.model';

@Component({
  selector: 'app-modal-alert',
  templateUrl: './modal-alert.component.html',
  styles: []
})

export class ModalAlertComponent implements OnInit {

  //Manipulamos la clase modal
  private _serverModel = new ServerModel;
  private _domainsModel = new DomainsModel;
  private _databasesModel = new DatabasesModel;
  private _backupModel = new BackupsModel;
  private _userModel = new UsersModel;
  private _notificationModel = new NotificationModel;
  private _storageModel = new StorageModel;
  private _networkModel = new NetworkModel;
  private _manualModel = new ManualModel;
  private _subdomainModel = new SubdomainModel;
  private _androidModel = new AndroidModel;
  private _qtoolsModel = new QtoolsModel;

  item : string;
  url: string;
  server : string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  deleteServer(){
    this.activeModal.close('Borrando datos');
    switch(this.url){
      case 'servers':
        this._serverModel.deleteServer(this.item);
      break;
      case 'domains':
        this._domainsModel.deleteDomain(this.item, this.server);
      break;
      case 'databases':
        this._databasesModel.deleteDatabase(this.item);
      break;
      case 'backups':
        this._backupModel.deleteBackup(this.item);
      break;
      case 'users':
        this._userModel.deleteUser(this.item);
      break;
      case 'notifications':
        this._notificationModel.deleteNotification(this.item);
      break;
      case 'storage':
        this._storageModel.deleteStorage(this.item);
      break;
      case 'networks':
        this._networkModel.deleteNetwork(this.item);
      break;
      case 'manuals':
        this._manualModel.deleteManual(this.item);
      break;
      case 'subdomains':
        this._subdomainModel.deletesubdomain(this.item);
      break;
      case 'android':
        this._androidModel.deleteAndroid(this.item);
      break;
      case 'qtools':
        this._qtoolsModel.deleteQtools(this.item);
      break;
    }
  }

}
